import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay, catchError } from 'rxjs/operators';

export interface Category {
  _id?: string;
  id: string;
  name: string;
  displayName: string;
  description?: string;
  count?: number;
  createdAt?: Date;
}

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  private apiUrl = 'https://aadinathapi.beatsacademy.in/api/categories';

  // Mock categories as fallback
  private mockCategories: Category[] = [
    { 
      id: 'cotton-bags', 
      name: 'Cotton Bags', 
      displayName: 'Cotton Bags',
      description: 'Eco-friendly cotton bags',
      count: 0 
    },
    { 
      id: 'canvas-tote-bags', 
      name: 'Canvas Tote Bags', 
      displayName: 'Canvas Tote Bags',
      description: 'Durable canvas tote bags',
      count: 0 
    },
    { 
      id: 'jute-bags', 
      name: 'Jute Bags', 
      displayName: 'Jute Bags',
      description: 'Natural jute bags',
      count: 0 
    },
    { 
      id: 'field-sample-bag', 
      name: 'Field Sample Bags', 
      displayName: 'Field Sample Bags',
      description: 'Sample collection bags',
      count: 0 
    }
  ];

  constructor(private http: HttpClient) {}

  getAllCategories(): Observable<Category[]> {
    return this.http.get<Category[]>(this.apiUrl).pipe(
      catchError(error => {
        console.log('API not available, using mock categories:', error);
        return of(this.mockCategories);
      })
    );
  }

  getCategoryById(id: string): Observable<Category | null> {
    return this.http.get<Category>(`${this.apiUrl}/${id}`).pipe(
      catchError(error => {
        const category = this.mockCategories.find(cat => cat.id === id);
        return of(category || null);
      })
    );
  }
}
